import { createContext, useContext } from "react";

export const ContextAgentContext = createContext(null);

const noop = () => {};

const fallback = {
  registration: null,
  open: false,
  setOpen: noop,
  toggleOpen: noop,
  setRegistration: noop,
  clearRegistration: noop,
  isRegistered: false,
  assistantLayout: "widget",
  widgetPanelDragRef: { current: null },
  widgetAnchor: { x: 0, y: 0 },
  setWidgetAnchor: noop,
  widgetPanelAnchor: null,
  setWidgetPanelAnchor: noop,
  widgetTaskQueueOpen: false,
  setWidgetTaskQueueOpen: noop,
};

export function useContextAgent() {
  const ctx = useContext(ContextAgentContext);
  return ctx ?? fallback;
}
